import { ref } from "vue";
import $ls, { LocalStorageKey } from "@/utils/local-storage";
import { trackTab } from "@/analytics/drawing-analytics";

/**
 * Modale « L'interface évolue » : présentation de la nouvelle interface de
 * l'outil dessin (refonte V5).
 * - Ouverte d'elle-même à la première entrée dans l'outil, sur chaque appareil.
 *   Une fois refermée, elle ne s'ouvre plus d'elle-même sur cet appareil.
 * - Rouvrable depuis le bouton en haut du volet Paramètres.
 * - Bouton et ouverture automatique disparaissent après UI_CHANGES_END_DATE.
 */

/** Dernier jour où la présentation est proposée (inclus). */
export const UI_CHANGES_END_DATE = "2027-01-31";

export const isUiChangesOpen = ref(false);

/** La présentation est encore proposée (bouton et ouverture automatique). */
export function isUiChangesAvailable(now: Date = new Date()): boolean {
  return now <= new Date(`${UI_CHANGES_END_DATE}T23:59:59`);
}

function hasSeenUiChanges(): boolean {
  try {
    return $ls.getItem(LocalStorageKey.CANVAS_UI_CHANGES_SEEN) === "1";
  } catch {
    // Stockage indisponible : ne pas l'imposer à chaque ouverture.
    return true;
  }
}

export function openUiChanges(source: "auto" | "settings") {
  isUiChangesOpen.value = true;
  trackTab(
    "settings",
    source === "auto"
      ? "ui_changes_shown_auto"
      : "ui_changes_opened_from_settings",
  );
}

/** À l'entrée dans l'outil : la première fois sur cet appareil seulement. */
export function autoOpenUiChanges(now: Date = new Date()) {
  if (isUiChangesAvailable(now) && !hasSeenUiChanges()) openUiChanges("auto");
}

/** Refermée (quelle que soit la façon) : plus d'ouverture automatique ici. */
export function closeUiChanges() {
  isUiChangesOpen.value = false;
  try {
    $ls.setItem(LocalStorageKey.CANVAS_UI_CHANGES_SEEN, "1");
  } catch {
    // Stockage indisponible : elle se rouvrira au prochain plan.
  }
}
